import { PropsWithChildren } from "react"
import { classNames } from "../../style/common";

export type WellProps = {
    className?: string | undefined
} & PropsWithChildren;

export function Well(props: WellProps) {
    return (
        <div className={classNames("space-y-4 p-4 lg:p-6 rounded shadow bg-secondary border border-color-border", props.className)}>
            {props.children}
        </div>
    )
}